/*
 * Copyright (C) 2026 Nex4Nova (Geoblast group)
 * SPDX-License-Identifier: Proprietary
 */
import { Routes, Route, Navigate } from 'react-router';
import Layout from './components/Layout/Layout';
import Home from './features/map/Home';
import Drillhole from './features/drillhole-3d/Drillhole';
import Drillhole2D from './features/strip-logs/Drillhole2D';
import DataInstructions from './features/data-instructions/DataInstructions';
import AnalyticsPlots from './features/analytics/AnalyticsPlots';
import './App.css';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/drillhole" element={<Drillhole />} />
        <Route path="/strip-log" element={<Drillhole2D />} />
        <Route path="/analytics" element={<AnalyticsPlots />} />
        <Route path="/data-instructions" element={<DataInstructions />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
